import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { clientDashboardPath2 } from 'Consts/Strings';
import { Redirect } from 'react-router';
import Layout from './Layout';

export { default as metaOverrideSet } from './MetaOverrideSet';

const ClientScenarioIntroPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.activeProposal.name]: () => {
      return (
        <Layout {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return <Redirect to={clientDashboardPath2} />;
    },
  });
};

export default ClientScenarioIntroPicker;
